import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ErrorHandler from 'common/error/components/error-handler';
import { injectIntl } from 'react-intl';
import Table from 'common/table/legacy-table';
import { Icon, Link, Div } from 'ui';
import styled from 'styled-components';

const DocumentsIcon = styled(Icon)`
  color: #0099cc;
  font-size: 22px;
  margin-left: 10px;
`;

const DocumentsLink = styled(Link)`
  color: #0099cc;
  text-decoration: underline;
`;

const Documents = ({ id, renderMenu, fetchDocuments, error, documents = [], isLoading, intl }) => {
  useEffect(() => {
    if (id) {
      fetchDocuments({ id });
    }
  }, [id]);

  const getColumns = () => {
    const { formatMessage: translate } = intl;

    return [
      {
        render: (text, record) => {
          if (record.documentType === 'Document') {
            return <DocumentsIcon type='file-word' />;
          }

          if (record.documentType === 'PDF') {
            return <DocumentsIcon type='file-pdf' />;
          }

          if (record.documentType === 'Excel') {
            return <DocumentsIcon type='file-excel' />;
          }

          return <DocumentsIcon type='file' />;
        },
      },
      {
        label: translate({ id: 'documents.table.FILENAME' }),
        dataIndex: 'name',
        render: (text, record) =>
          <DocumentsLink>
            {record.name}
          </DocumentsLink>
        ,
      },
      {
        label: translate({ id: 'documents.table.CREATION_DATE' }),
        dataIndex: 'creationDate',
        format: 'date',
      },
      {
        label: translate({ id: 'documents.table.SOURCE' }),
        dataIndex: 'source',
      },
    ];
  };

  const navigateToDocument = (url) => {
    if (url.startsWith('http')) {
      window.open(url, '_blank');
      return;
    }
    window.open(`http://${url}`, '_blank');
  };

  return (
    <>
      {renderMenu()}
      <ErrorHandler type='notification' error={error} />
      <Div marginTop={25}>
        <Table
          columns={getColumns()}
          data={documents}
          hasRowSelector={false}
          isLoading={isLoading}
          onRowClick={item => navigateToDocument(item.url)}
        />
      </Div>
    </>
  );
};

Documents.propTypes = {
  id: PropTypes.string.isRequired,
  renderMenu: PropTypes.func.isRequired,
  fetchDocuments: PropTypes.func.isRequired,
  error: PropTypes.object,
  documents: PropTypes.array,
  isLoading: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default injectIntl(Documents);
